import { Maybe } from '@/utils/types'
import { ContentItemType } from '../types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'brand_landing'

/**
 * Interaction builder for items in brand landing page tabs
 * Used for tracking user interactions with content in episodes, extras, and franchise/collection tabs
 */
export class BrandLandingTabItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ContentItemType>; attribution: unknown }) {
    super(item)
  }
}
